export const siteLogo = {
    logo: "assets/images/wonted-logo.png",  // Add your site logo here
    alt: "Wonted"  // Add your site name here
};
export const socialLink = {
    facebook: "https://www.facebook.com/people/Sanjeet-Das/pfbid0Xc9Cam33TWXRdcB98ojB9HnUEoamfhmGb7A4fWhngLgdurHgNBjcNBVr1z89Qw7gl/?rdid=qfIc2XDC8DtZfZOO&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19AYwq1PXo%2F",
    twitter: "https://www.twitter.com",
    linkedin: "https://www.linkedin.com",
    youtube: "https://www.youtube.com",
    whatsapp: "https://www.whatsapp.com",
};
export const mailchimpLink = {
    link: (process.env.REACT_APP_MAILCHAIMP) // Add your mailchimp list link here
};
export const contactFormAction = {
    link: (process.env.REACT_APP_CONTACTFORM)  // Add for link here from https://formspree.io
}
export const contactMap = {
    link: (process.env.REACT_APP_CONTACTMAP) // Add google map link from here: https://www.embedgooglemap.net/
}
